import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { VayuBlocksHeaderTab, usePanelSettings } from '@vayu-blocks';
import Faq from './faq.js';
import Style from './style.js';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';

const panelKeys = [
	'faq-panel',
	'faq-icon',

	'faq-container',
	'faq-icon',
	'faq-question',
	'faq-answer'
];

const initialPanels = {
	slide: 'faq-panel',
	overlay: '',
	advanced: ''
};

const panelOptions = [
	{ label: __('Faq', 'vayu-blocks'), value: 'slide', icon: 'faq' },
	{ label: __('Style', 'vayu-blocks'), value: 'overlay', icon: 'colorwand' },
	{ label: __('Advanced', 'vayu-blocks'), value: 'advanced', icon: 'colorpalette' },
];

const PanelSettings = ({ attributes, setAttributes, isSelected, clientId }) => {

	const {tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide'});

	const tabComponents = {
		slide: <Faq attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		overlay: <Style attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} openPanels={openPanels} onTogglePanel={onTogglePanel} exclude={['Cursor', 'cursorFollower']} />,
	};

	return (
		isSelected && (
			<InspectorControls>
				<div className="th-block-ins th-button-panel">
					<VayuBlocksHeaderTab
						value={tab}
						options={panelOptions}
						onChange={setTab}
					/>

					{tabComponents[tab]}

				</div>
			</InspectorControls>
		)
	);
};

export default PanelSettings;
